function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.79,251.5c-5,42-24.12,90.8-62.41,113.22-57.84,33.89-53,86-165.91,108.67a232.09,232.09,0,0,1-50.06,4.73,194.69,194.69,0,0,1-24.58-2c-71.76-10.49-120-60.37-137.76-120.58-23.32-79.19,23.24-131,54.09-162.27S131.62,64.71,242.44,41.56a224.63,224.63,0,0,1,51.46-4.88c39.43,1,82.43,13.91,112.19,40.93q3.36,3,6.53,6.31C454,126.37,471.56,194.26,464.79,251.5Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.79,251.5c-5,42-24.12,90.8-62.41,113.22-57.84,33.89-53,86-165.91,108.67a232.09,232.09,0,0,1-50.06,4.73,194.69,194.69,0,0,1-24.58-2c-71.76-10.49-120-60.37-137.76-120.58-23.32-79.19,23.24-131,54.09-162.27S131.62,64.71,242.44,41.56a224.63,224.63,0,0,1,51.46-4.88c39.43,1,82.43,13.91,112.19,40.93q3.36,3,6.53,6.31C454,126.37,471.56,194.26,464.79,251.5Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Furniture--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.41,306.77h-.12a.51.51,0,0,1-.37-.6c0-.2,4.58-19.75,10.42-29.68a.5.5,0,1,1,.86.51c-5.76,9.79-10.26,29.2-10.31,29.39A.5.5,0,0,1,268.41,306.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.06,285.35s2.37-3.23,6-1.72,1.08,4.09-1.4,4.2S275.06,285.35,275.06,285.35Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.54,288.33c-2.62,0-4.77-2.55-4.87-2.66a.51.51,0,0,1,0-.61s2.65-3.53,6.63-1.89c2.08.86,2.21,2,2.11,2.64-.25,1.42-2.11,2.45-3.68,2.52Zm-3.81-3c.63.64,2.24,2.08,3.94,2,1.26-.05,2.59-.87,2.73-1.69s-.88-1.29-1.5-1.55A4.58,4.58,0,0,0,275.73,285.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.47,294.19s2.37-3.23,6-1.73,1.08,4.1-1.4,4.2S272.47,294.19,272.47,294.19Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,297.17c-2.61,0-4.77-2.55-4.86-2.66a.5.5,0,0,1,0-.62s2.65-3.53,6.62-1.89c2.09.86,2.22,2,2.11,2.65-.25,1.42-2.1,2.45-3.67,2.51Zm-3.81-3c.63.64,2.24,2.06,3.94,2,1.26-.05,2.59-.87,2.74-1.69s-.89-1.29-1.51-1.55A4.57,4.57,0,0,0,273.14,294.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.94,276.74s.32-8.08,4.84-6.79S282.71,277.6,278.94,276.74Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.67,277.32a3.47,3.47,0,0,1-.85-.1.49.49,0,0,1-.38-.5c0-.21.23-5.11,2.59-6.82a3.2,3.2,0,0,1,2.89-.43,2.42,2.42,0,0,1,1.95,3.09A7.24,7.24,0,0,1,279.67,277.32Zm-.2-1c2.13.15,4.95-2.11,5.43-4,.25-.95-.17-1.57-1.25-1.88a2.28,2.28,0,0,0-2,.28C280,271.87,279.58,275.11,279.47,276.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.81,282.12s-.32-6.35-3.23-4.84S271.93,280.61,275.81,282.12Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.81,282.62a.57.57,0,0,1-.18,0c-3.21-1.25-4.8-2.47-4.87-3.73,0-.78.49-1.46,1.59-2a2,2,0,0,1,2-.05c1.73,1,2,4.88,2,5.32a.49.49,0,0,1-.21.43A.5.5,0,0,1,275.81,282.62Zm-2.39-5.08a1.35,1.35,0,0,0-.61.18c-.49.25-1.07.65-1.05,1.09,0,.26.32,1.2,3.48,2.54-.17-1.43-.63-3.25-1.43-3.7A.79.79,0,0,0,273.42,277.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.69,310.93a.51.51,0,0,1-.5-.49,60.2,60.2,0,0,0-5-21.13.5.5,0,0,1,.91-.41,61.21,61.21,0,0,1,5.13,21.52.5.5,0,0,1-.49.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.93,295.8s-4.85-2.15-6-.43-.32,4.74,2.58,4A4.84,4.84,0,0,0,264.93,295.8Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.62,300a2.55,2.55,0,0,1-2.19-1.09,3.42,3.42,0,0,1,.06-3.79c1.38-2,6.11,0,6.64.26a.48.48,0,0,1,.29.55,5.28,5.28,0,0,1-3.81,3.94A3.85,3.85,0,0,1,260.62,300Zm0-4.77a1.5,1.5,0,0,0-1.28.46,2.43,2.43,0,0,0-.06,2.65,1.82,1.82,0,0,0,2.11.56,4.23,4.23,0,0,0,3-2.78A11.82,11.82,0,0,0,260.59,295.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.07,291.49s1.51-4.84,3.77-3.12.11,3.55-1,3.88S264.07,291.49,264.07,291.49Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.42,292.81a6,6,0,0,1-2.62-.89.51.51,0,0,1-.21-.57c.1-.33,1.05-3.23,2.73-3.76a1.92,1.92,0,0,1,1.82.38,2.4,2.4,0,0,1,1.16,2.4,3.51,3.51,0,0,1-2.29,2.36A2.21,2.21,0,0,1,266.42,292.81Zm-1.74-1.54a3.43,3.43,0,0,0,2.05.5,2.52,2.52,0,0,0,1.59-1.58c.09-.48-.18-1-.78-1.42a.94.94,0,0,0-.92-.23C265.76,288.81,265,290.38,264.68,291.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.25,316.5a.49.49,0,0,1-.5-.49c0-1.25-.61-30.7,1.43-40.67a.51.51,0,0,1,.59-.39.5.5,0,0,1,.39.59c-2,9.87-1.42,40.14-1.41,40.45a.52.52,0,0,1-.49.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.76,263.81s-4.09-2.8-7.64-1.08-6.57,9.81-2.59,12.93,11.31.21,13-5.71S273.76,263.81,273.76,263.81Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.44,277.43a6.72,6.72,0,0,1-4.22-1.38c-1.57-1.23-2.29-3.3-2-5.82.35-3.35,2.42-6.84,4.7-8,3.48-1.68,7.32.59,8,1a4.11,4.11,0,0,1,2.77,1.59c.87,1.21,1,3,.34,5.18a10.47,10.47,0,0,1-6.81,6.89A9.4,9.4,0,0,1,267.44,277.43Zm1.21-14.75a5.29,5.29,0,0,0-2.31.5c-2,1-3.83,4.17-4.15,7.16-.23,2.16.35,3.91,1.65,4.93a6.49,6.49,0,0,0,6.09.75,9.44,9.44,0,0,0,6.16-6.21c.55-1.9.49-3.36-.19-4.31a3.11,3.11,0,0,0-2.16-1.19.62.62,0,0,1-.26-.09A9.88,9.88,0,0,0,268.65,262.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.94,273.21a2.81,2.81,0,0,1-2.33-1c-.82-1.07-.64-2.65.49-4.35a12.35,12.35,0,0,1,6.54-4.51.5.5,0,1,1,.25,1,11.61,11.61,0,0,0-6,4.11c-.86,1.3-1.06,2.49-.53,3.18s1.65.81,3,.37a5.56,5.56,0,0,0,3.28-3.31,1.25,1.25,0,0,0,.08-.8l-.1,0c-1.71.32-3.25,1.54-3.25,2a.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5c0-1.22,2.22-2.62,4.07-3a1,1,0,0,1,1.26.76c.36,1.4-1.33,4.37-4,5.27A5.48,5.48,0,0,1,268.94,273.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.63,281s-2,3.52-.43,6.33,8.43,4.81,10.75,1.35-.49-9.28-5.45-10.34S254.63,281,254.63,281Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,291h-.29c-2.8-.1-5.81-1.6-6.87-3.43-1.6-2.76,0-6.05.37-6.72a3.4,3.4,0,0,1,1.16-2.41c1-.8,2.41-1,4.3-.6a8.69,8.69,0,0,1,6.12,5.22,6.25,6.25,0,0,1-.35,5.89A5.11,5.11,0,0,1,260.93,291Zm-3.07-12.36a3,3,0,0,0-1.92.57,2.49,2.49,0,0,0-.81,1.77.48.48,0,0,1-.07.26s-1.88,3.31-.42,5.83c.88,1.53,3.59,2.85,6,2.93a4.36,4.36,0,0,0,3.86-1.61,5.28,5.28,0,0,0,.25-4.95,7.67,7.67,0,0,0-5.4-4.62A7.36,7.36,0,0,0,257.86,278.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.48,287a4.53,4.53,0,0,1-2.19-.67,10.3,10.3,0,0,1-4.13-5.14.5.5,0,1,1,.94-.32,9.54,9.54,0,0,0,3.68,4.59c1.08.61,2,.71,2.54.26s.53-1.34.11-2.36a4.48,4.48,0,0,0-2.6-2.37,1.33,1.33,0,0,0-.85-.1,4.18,4.18,0,0,0,1.79,2.46h0a.51.51,0,0,1,.51.48.49.49,0,0,1-.45.52c-1.12.05-2.4-1.86-2.76-3.23a.92.92,0,0,1,.6-1.19c1.15-.38,3.76.85,4.67,3,.6,1.45.47,2.76-.36,3.5A2.26,2.26,0,0,1,260.48,287Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.34,322.75V302.94h-5.28v19.57c-4.16,2.59-7.24,11-7.24,14.47,0,4.1,4.34,7.43,9.68,7.43s9.69-3.33,9.69-7.43C278.19,333.63,275.3,325.6,271.34,322.75Z",
    style: {
      fill: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.51,344.91c-5.62,0-10.19-3.56-10.19-7.93,0-3.54,3-11.86,7.24-14.74v-19.3a.5.5,0,0,1,.5-.5h5.28a.5.5,0,0,1,.5.5V322.5c4,3.1,6.85,11.18,6.85,14.48C278.69,341.35,274.12,344.91,268.51,344.91Zm-1.95-41.47v19.07a.52.52,0,0,1-.24.43c-4,2.47-7,10.81-7,14,0,3.82,4.12,6.93,9.19,6.93s9.18-3.11,9.18-6.93c0-3.1-2.81-11.06-6.64-13.82a.52.52,0,0,1-.21-.41V303.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.48,
    y: 346.75,
    width: 64.97,
    height: 73.89,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.45,421.14h-65a.5.5,0,0,1-.5-.5V346.75a.5.5,0,0,1,.5-.5h65a.5.5,0,0,1,.5.5v73.89A.5.5,0,0,1,303.45,421.14Zm-64.47-1h64V347.25H239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.45,421.14H287.39a.5.5,0,0,1-.5-.5V346.75a.5.5,0,0,1,.5-.5h16.06a.5.5,0,0,1,.5.5v73.89A.5.5,0,0,1,303.45,421.14Zm-15.56-1H303V347.25H287.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.79,
    y: 344,
    width: 72.05,
    height: 3.69,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.83,348.2h-72a.5.5,0,0,1-.5-.5V344a.5.5,0,0,1,.5-.5h72a.5.5,0,0,1,.5.5v3.7A.5.5,0,0,1,306.83,348.2Zm-71.54-1h71v-2.7h-71Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.77,210.23H325.48a.5.5,0,0,1-.5-.5V147.11a.5.5,0,0,1,.5-.5h50.29a.5.5,0,0,1,.5.5v62.62A.51.51,0,0,1,375.77,210.23Zm-49.79-1h49.29V147.61H326Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,206.8H328.23a.5.5,0,0,1-.5-.5V150.53a.5.5,0,0,1,.5-.5H373a.51.51,0,0,1,.5.5V206.3A.5.5,0,0,1,373,206.8Zm-44.29-1h43.79V151H328.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.64,188.91h-16a.51.51,0,0,1-.5-.5v-20a.5.5,0,0,1,.5-.5h16a.5.5,0,0,1,.5.5v20A.5.5,0,0,1,358.64,188.91Zm-15.54-1h15v-19h-15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.85,210.23H390.56a.5.5,0,0,1-.5-.5V147.11a.5.5,0,0,1,.5-.5h50.29a.5.5,0,0,1,.5.5v62.62A.5.5,0,0,1,440.85,210.23Zm-49.79-1h49.29V147.61H391.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.1,206.8H393.31a.5.5,0,0,1-.5-.5V150.53a.5.5,0,0,1,.5-.5H438.1a.5.5,0,0,1,.5.5V206.3A.5.5,0,0,1,438.1,206.8Zm-44.29-1H437.6V151H393.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.73,188.91H407.68a.51.51,0,0,1-.5-.5v-20a.5.5,0,0,1,.5-.5h16.05a.5.5,0,0,1,.5.5v20A.51.51,0,0,1,423.73,188.91Zm-15.55-1h15.05v-19H408.18Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.68,350.76H126.31a.5.5,0,0,1-.5-.5V89.91a.5.5,0,0,1,.5-.5h97.37a.5.5,0,0,1,.5.5V350.26A.5.5,0,0,1,223.68,350.76Zm-96.87-1h96.37V90.41H126.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.29,350.76H22.91a.51.51,0,0,1-.5-.5V89.91a.5.5,0,0,1,.5-.5h97.38a.5.5,0,0,1,.5.5V350.26A.51.51,0,0,1,120.29,350.76Zm-96.88-1h96.38V90.41H23.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.55,184.29a.51.51,0,0,1-.36-.15.5.5,0,0,1,0-.7l6.79-6.79a.5.5,0,0,1,.71,0,.51.51,0,0,1,0,.71l-6.79,6.78A.5.5,0,0,1,140.55,184.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.42,172.41a.54.54,0,0,1-.35-.14.5.5,0,0,1,0-.71l67.86-67.86a.5.5,0,0,1,.71,0,.48.48,0,0,1,0,.7l-67.86,67.87A.54.54,0,0,1,152.42,172.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.57,162.23a.46.46,0,0,1-.35-.14.5.5,0,0,1,0-.71l11.31-11.31a.48.48,0,0,1,.7,0,.5.5,0,0,1,0,.71l-11.31,11.31A.47.47,0,0,1,179.57,162.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,252.72a.51.51,0,0,1-.36-.15.5.5,0,0,1,0-.7l22.63-22.62a.49.49,0,0,1,.7.7L157.3,252.57A.49.49,0,0,1,157,252.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.4,227.27a.51.51,0,0,1-.36-.15.5.5,0,0,1,0-.7l3.4-3.4a.5.5,0,0,1,.7,0,.5.5,0,0,1,0,.71l-3.39,3.39A.49.49,0,0,1,182.4,227.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.05,148.1a.5.5,0,0,1-.35-.15.5.5,0,0,1,0-.71l19.79-19.79a.5.5,0,0,1,.71.71L37.41,148A.51.51,0,0,1,37.05,148.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.22,122.93a.47.47,0,0,1-.35-.15.48.48,0,0,1,0-.7l5.37-5.38a.5.5,0,0,1,.71.71l-5.38,5.37A.47.47,0,0,1,62.22,122.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.27,299.09a.5.5,0,0,1-.36-.14.51.51,0,0,1,0-.71L80,248.19a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71l-50,50A.49.49,0,0,1,30.27,299.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.38,284.11A.51.51,0,0,1,33,284a.51.51,0,0,1,0-.71l8.2-8.2a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71l-8.2,8.2A.49.49,0,0,1,33.38,284.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.09,407.53a.5.5,0,0,1-.5-.5V90.33a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V407A.51.51,0,0,1,291.09,407.53Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.5,270.48a36.08,36.08,0,0,1,5.25,8.64c1.85,4.64,1.54,8.19,3.71,10s5.56,2.78,4.32,5.25a17.26,17.26,0,0,1-4.32,4.79s-1.7,11-3.56,12.51-11.58.15-11.58.15l-3.24,7.57L166.47,323s3.7-26.87,5.87-31.66,17.91-19.45,18.84-20.54S195.5,270.48,195.5,270.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.47,323.48a.5.5,0,0,1-.5-.57c.15-1.1,3.74-27,5.91-31.79,1.76-3.9,11.89-13.77,16.76-18.52,1.1-1.08,2-1.94,2.16-2.14,1.07-1.25,4.19-.61,4.81-.47a.47.47,0,0,1,.27.16,36.4,36.4,0,0,1,5.33,8.79,32.93,32.93,0,0,1,1.51,5.06c.49,2.11.89,3.77,2.06,4.78a16,16,0,0,0,1.89,1.33c1.71,1.1,3.65,2.33,2.56,4.53a16.84,16.84,0,0,1-4.31,4.83c-.29,1.81-1.84,11.07-3.7,12.62s-9.58.59-11.59.32l-3.09,7.22a.52.52,0,0,1-.37.29l-19.61,3.55Zm26.7-52.77a2.36,2.36,0,0,0-1.62.4c-.19.23-.85.88-2.22,2.21-4.44,4.33-14.86,14.49-16.54,18.21-1.92,4.24-5.14,26.62-5.73,30.84L185.73,319l3.13-7.32a.51.51,0,0,1,.53-.29c3.68.52,10,1,11.19-.05s2.74-8,3.38-12.2a.48.48,0,0,1,.2-.32,16.65,16.65,0,0,0,4.17-4.61c.63-1.26-.18-1.95-2.19-3.23a17.38,17.38,0,0,1-2-1.42c-1.42-1.22-1.85-3-2.39-5.31a32.94,32.94,0,0,0-1.45-4.92,35.59,35.59,0,0,0-5.07-8.38A10.38,10.38,0,0,0,193.17,270.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.32 311.86 184.53 310.94 187.31 316.65 189.32 311.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.32,317.15a.49.49,0,0,1-.45-.28l-2.78-5.72a.47.47,0,0,1,0-.52.51.51,0,0,1,.49-.19l4.79.93a.49.49,0,0,1,.34.25.5.5,0,0,1,0,.43l-2,4.79a.52.52,0,0,1-.45.31Zm-1.9-5.53,1.86,3.82,1.34-3.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68,301.55h0a7.4,7.4,0,0,1-5-2.34.5.5,0,1,1,.76-.64,6.56,6.56,0,0,0,4.28,2,.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.81,288.47c.29,1.07.13,2-.37,2.18S199.31,290,199,289s-.12-2,.37-2.18S200.52,287.4,200.81,288.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.27,284.57a.51.51,0,0,1-.34-.14.5.5,0,0,1,0-.71c.1-.1,2.46-2.59,4.63-1.32a.49.49,0,0,1,.18.68.51.51,0,0,1-.69.18c-1.48-.87-3.37,1.13-3.39,1.15A.54.54,0,0,1,196.27,284.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.35,399.77s1.56,15,5.86,19.73,10.95,5.1,15.44,5.49,76,2.15,81.06-3.32,4.49-7.05,4.49-7.05,16.6-10.36,4.69-21.49c-4.22-3.94-31.26-9.77-44.93-10s-17.39.58-17.39.58-.58,8.21-2.73,11.33-17,8.79-27.93,10.16A25.09,25.09,0,0,1,144.35,399.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.86,426.06c-16.39,0-30.86-.45-32.26-.57l-.47,0c-4.65-.4-11-.94-15.29-5.61s-5.92-19.4-6-20a.5.5,0,0,1,.27-.49.48.48,0,0,1,.56.07,24.86,24.86,0,0,0,18.16,5.34c11-1.36,25.57-7,27.59-9.94s2.64-11,2.65-11.08a.5.5,0,0,1,.39-.46c.15,0,3.93-.78,17.5-.59,13.29.19,40.73,5.86,45.26,10.09,3.27,3.06,4.75,6.35,4.42,9.8-.64,6.5-7.49,11.36-8.93,12.32,0,.83-.69,2.88-4.64,7.13C244,425.29,219.3,426.06,197.86,426.06ZM145,400.92c.48,3.64,2.15,14.49,5.59,18.24,4,4.38,10.15,4.91,14.64,5.3l.47,0c5.34.46,75.9,2,80.66-3.17,4.6-4.95,4.37-6.57,4.37-6.58a.44.44,0,0,1,.22-.56c.08-.05,8.07-5.11,8.71-11.73.3-3.12-1.08-6.14-4.1-9-4-3.75-30.69-9.62-44.6-9.82-11.16-.16-15.68.34-16.91.51-.15,1.71-.84,8.35-2.79,11.19-2.35,3.42-17.69,9-28.28,10.37A25.39,25.39,0,0,1,145,400.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.89,345.59l-9.55,30.74S130.48,391,127.74,399s-9.37,21.68-9.37,21.68-8.79,1-11.92,2-5.66,2.14-6.25,2.34S124,425,124,425s.78-.2,2.54-4.1,2.93-7.23,2.93-7.23l18.95-27.93s.76-35.62-.42-44.61S145.89,345.59,145.89,345.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.44,425.58c-3.64,0-5.29,0-6.06-.14h0c-.6-.08-.63-.2-.65-.37a.51.51,0,0,1,.34-.56l.88-.36c1.16-.48,3.11-1.28,5.38-2,2.86-.9,10.2-1.77,11.74-1.94.91-1.89,6.74-14.08,9.23-21.38,2.71-7.93,8.55-22.54,8.6-22.69l9.52-30.64c.58-7.95,1.37-8,1.8-8s.95.51,1.34,3.53c1.16,8.92.45,43.22.42,44.68a.46.46,0,0,1-.09.27L130,413.87c-.17.47-1.31,3.61-2.92,7.2s-2.5,4.29-2.88,4.39H124C115.54,425.54,110,425.58,106.44,425.58Zm-3.86-1c4.42,0,14.27,0,21.34-.08.1-.1.83-.77,2.2-3.81,1.72-3.84,2.9-7.15,2.91-7.19a.24.24,0,0,1,.06-.11L148,385.55c.05-2.51.7-35.83-.41-44.39-.13-1-.25-1.62-.34-2a52.37,52.37,0,0,0-.82,6.5.36.36,0,0,1,0,.11l-9.54,30.74c-.08.18-5.9,14.77-8.6,22.67s-9.34,21.6-9.4,21.74a.51.51,0,0,1-.4.28c-.08,0-8.78,1-11.82,1.93C105.06,423.58,103.67,424.11,102.58,424.55Zm43.3-79h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.92,318.07s7.45-3.86,11.94,3.76,10.36,29.5,11.92,33,5.08,10.36,19.53,20.9,20.32,12.9,20.32,12.9,12.3-3.13,14.84-2.54,9,6.25,9.18,7.22-1.56,1.76-2.53,1.76h-1a21.28,21.28,0,0,0-8,.59c-3.91,1.17-10.55,1.37-13.28.58a64,64,0,0,1-7.82-3.32s-18.55-8.59-28.52-14.26-15.43-18.55-15.43-18.55,2.54,18.36,4.1,21.29,3.13,0,1.18,7.23,4.68,9-14.66,16.8-25.59,7.42-29.69,4.49-6.64-11.53-6-15.24a93.55,93.55,0,0,0,1.17-23.63c-1-10.75.31-32.43.5-33.4s4.93-13.11,19.59-17.41S177.92,318.07,177.92,318.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.63,412.35a11.23,11.23,0,0,1-6.91-2c-4.26-3-6.87-11.83-6.26-15.73l.07-.43a92.2,92.2,0,0,0,1.1-23.08c-1-10.88.32-32.59.51-33.54.4-2,5.75-13.63,19.93-17.79,11.26-3.3,12.82-2.85,13.23-2.4,1.94-.75,8.08-2.44,12,4.21,3.09,5.23,6.85,17.25,9.34,25.21,1.18,3.77,2.12,6.75,2.6,7.85,1.19,2.66,4.32,9.71,19.38,20.7,13,9.48,19.07,12.33,20.06,12.77,1.86-.47,12.42-3.08,14.92-2.5s9.28,6.23,9.56,7.62a1.37,1.37,0,0,1-.34,1.16,3.91,3.91,0,0,1-2.69,1.19h-1a21,21,0,0,0-7.87.57c-3.84,1.15-10.56,1.44-13.56.59a63.32,63.32,0,0,1-7.9-3.36c-.17-.08-18.68-8.66-28.54-14.27-7.19-4.09-12-11.74-14.24-15.92,1,6.65,2.57,16.06,3.59,18a3.33,3.33,0,0,0,1.22,1.36c1.17.8,1.3,1.42,0,6.24a14.15,14.15,0,0,0-.38,4.44c.16,4.41-.42,7-14.57,12.69C168.29,410.58,161.3,412.35,156.63,412.35ZM177.09,318c-1,0-3.86.38-11.73,2.69-15,4.41-19.21,16.9-19.24,17-.18.95-1.47,22.46-.49,33.26a93.86,93.86,0,0,1-1.11,23.32l-.07.44c-.56,3.58,1.94,12,5.85,14.75s10.29,3.1,29.22-4.55c14.15-5.72,14.07-8,13.94-11.72a15,15,0,0,1,.41-4.74c1.24-4.59,1-4.75.41-5.15a4.37,4.37,0,0,1-1.54-1.72c-1.58-3-4.05-20.7-4.15-21.46a.5.5,0,0,1,.95-.26c.05.13,5.52,12.81,15.22,18.32s28.3,14.15,28.48,14.24a66,66,0,0,0,7.74,3.29c2.55.73,9.05.61,13-.58a21.31,21.31,0,0,1,8.22-.6h.91a3,3,0,0,0,1.92-.82c.15-.19.13-.3.12-.34-.27-.79-6.34-6.27-8.8-6.84-2-.46-11.22,1.68-14.61,2.54a.47.47,0,0,1-.31,0c-.24-.1-6.08-2.49-20.42-13C205.75,365,202.53,357.77,201.32,355c-.51-1.14-1.45-4.15-2.64-8-2.48-7.91-6.22-19.86-9.25-25-4.19-7.11-11-3.71-11.28-3.56a.51.51,0,0,1-.63-.14.55.55,0,0,1-.1-.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.9,388.85c2-7.21.43-4.29-1.11-7.23s-3.92-21.33-3.92-21.33.51,1.24,1.51,3.12l-10.71-24.49s-.94-4.7,3.4-9.15a13.13,13.13,0,0,1,8.72-4A35.62,35.62,0,0,0,190,322c-4.43-7.65-11.91-3.86-11.91-3.86s-.84-5.65-15.52-1.48a21.74,21.74,0,0,0-16.2,18.2c-.2,1-2.4,25.24-1.52,36a93.2,93.2,0,0,1-1.37,23.63c-.61,3.7,1.85,12.32,5.93,15.28s10.33,3.41,29.73-4.24S191.89,396.07,193.9,388.85Z",
    style: {
      fill: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.14,412.25a11.25,11.25,0,0,1-7-2.07c-4.24-3.08-6.78-11.88-6.13-15.78L143,394a92.87,92.87,0,0,0,1.3-23.07c-.87-10.56,1.27-34.93,1.52-36.13,0,0,0-.13,0-.24a22.28,22.28,0,0,1,16.51-18.34c8.6-2.45,12.6-1.54,14.45-.35a3.91,3.91,0,0,1,1.5,1.65c1.84-.72,8.13-2.51,12.05,4.27a36.68,36.68,0,0,1,1.85,3.79.5.5,0,0,1,0,.46.49.49,0,0,1-.4.24,12.74,12.74,0,0,0-8.38,3.87,10.63,10.63,0,0,0-3.28,8.66l10.69,24.43a.5.5,0,0,1-.24.65.5.5,0,0,1-.66-.21c-.05-.1-.1-.2-.16-.3.93,6.66,2.44,16.1,3.45,18a3.39,3.39,0,0,0,1.21,1.36c1.16.81,1.29,1.43-.06,6.24h0a14.25,14.25,0,0,0-.41,4.44c.12,4.41-.48,7-14.68,12.57C167.79,410.53,160.8,412.25,156.14,412.25Zm15.51-96.62a33.66,33.66,0,0,0-9,1.52c-11.82,3.36-15,12.43-15.79,17.54,0,.13,0,.22,0,.28-.14.68-2.4,25-1.51,35.85a93.29,93.29,0,0,1-1.3,23.32l-.07.43c-.6,3.57,1.83,12,5.73,14.8s10.26,3.18,29.25-4.3c14.2-5.61,14.14-7.87,14-11.61a14.6,14.6,0,0,1,.45-4.74h0c1.28-4.57,1-4.74.45-5.15a4.21,4.21,0,0,1-1.52-1.72c-1.56-3-3.88-20.74-4-21.49a.47.47,0,0,1,0-.24l-9.19-21,0-.1c0-.2-.94-5,3.53-9.6a13.78,13.78,0,0,1,8.34-4.11c-.54-1.22-1.05-2.24-1.51-3.05-4.14-7.14-11-3.8-11.26-3.66a.51.51,0,0,1-.45,0,.54.54,0,0,1-.27-.37,2.61,2.61,0,0,0-1.31-1.59A8.64,8.64,0,0,0,171.65,315.63Zm22.25,73.22h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.88,297.68s15-13.72,18.32-20.23,6.18-3.21,5.3-8.35-16.07-9.32-30.58-3.68-17.37,17-17.44,24.28.47,17.89.45,19.76-16.88-5.12-20.82,6.36,3,13.72,2.48,17-7.29,6.63-4,13,9.05,3.35,8.71,6.46,1.47,8.1,7.78,8.15,13.26-3.46,12.41-12.65-.64-15.25,1.53-16.64,11.55-1.45,15.3-8.74-.19-13.69-.47-17A27,27,0,0,1,177.88,297.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.27,360.94h-.15a8.24,8.24,0,0,1-6.33-2.58,8.15,8.15,0,0,1-1.94-6.13c.08-.8-.25-1-1.84-1.28a8.71,8.71,0,0,1-6.82-4.88c-2.38-4.57.07-7.68,2-10.18a8.15,8.15,0,0,0,1.87-3.17c.13-.86-.44-1.74-1.15-2.84-1.61-2.48-4.05-6.23-1.3-14.22,3-8.62,12.73-7.32,18-6.62a16.07,16.07,0,0,0,2.82.24c0-.71-.05-2.26-.12-4.17-.15-4.2-.37-10.55-.33-15.42C153,283,155.42,270.9,170.74,265c10.74-4.18,22.12-3.1,27.8.12,2,1.14,3.21,2.5,3.45,3.94.5,2.92-.17,3.48-1.5,4.29a9.2,9.2,0,0,0-3.84,4.38c-3.18,6.29-16.86,18.93-18.33,20.27a26.31,26.31,0,0,0-.93,7.46,16.5,16.5,0,0,0,.72,3c1.09,3.65,2.58,8.65-.3,14.25s-8.72,7-12.61,8a12.09,12.09,0,0,0-2.87.93c-2.63,1.67-1.63,12.58-1.3,16.16.35,3.82-.56,6.94-2.71,9.28A13.53,13.53,0,0,1,148.27,360.94Zm-3.66-51.4c-4.44,0-9.21,1.17-11,6.44-2.59,7.54-.41,10.9,1.19,13.35.79,1.24,1.49,2.3,1.3,3.54A8.61,8.61,0,0,1,134,336.5c-1.87,2.4-4,5.11-1.93,9.1a7.76,7.76,0,0,0,6.15,4.37c1.38.29,2.81.59,2.62,2.37a6.82,6.82,0,0,0,7.29,7.6c3.85,0,7.32-1.28,9.46-3.6,1.95-2.12,2.77-5,2.45-8.51-1-10.58-.45-15.69,1.75-17.1a12.56,12.56,0,0,1,3.17-1.05c3.71-.93,9.31-2.35,12-7.5s1.27-10,.23-13.51a17.44,17.44,0,0,1-.76-3.18,27,27,0,0,1,1-7.95.46.46,0,0,1,.14-.23c.15-.14,15-13.73,18.21-20.08a10.19,10.19,0,0,1,4.22-4.78c1.05-.65,1.45-.89,1-3.27-.19-1.12-1.24-2.27-3-3.24-5.48-3.11-16.49-4.12-27-.06C156.33,271.62,154,283.27,154,289.7c0,4.85.18,11.18.33,15.37.07,2.18.13,3.76.12,4.39a.75.75,0,0,1-.26.57c-.48.41-1.41.3-3.69,0A43.64,43.64,0,0,0,144.61,309.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.65,297.39s-5.63-7.36-8.27-4.74-.51,6.07,1.61,9.35,5,3.16,5.52,2.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4,305.39h-.13c-.64,0-2.89-.31-4.7-3.11-2-3.12-4.53-7-1.54-10a2.37,2.37,0,0,1,1.92-.7c3,.2,6.93,5.27,7.1,5.49a.51.51,0,0,1-.1.7.5.5,0,0,1-.7-.09c-1.05-1.37-4.24-5-6.37-5.11a1.43,1.43,0,0,0-1.15.42c-2.23,2.22-.63,5.14,1.68,8.72a5.18,5.18,0,0,0,3.7,2.64,1.46,1.46,0,0,0,1-.14.5.5,0,1,1,.79.61A1.87,1.87,0,0,1,178.4,305.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.15,401.54a.51.51,0,0,1-.44-.26.5.5,0,0,1,.2-.68,14.48,14.48,0,0,0,2.94-2.16.5.5,0,0,1,.69.73,15.59,15.59,0,0,1-3.15,2.31A.53.53,0,0,1,179.15,401.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.44,396.8a.54.54,0,0,1-.3-.1.52.52,0,0,1-.1-.71c4.68-6.11,6.49-14.79,6.51-14.88a.49.49,0,0,1,.58-.39.51.51,0,0,1,.4.59c-.08.37-1.87,9-6.69,15.29A.51.51,0,0,1,184.44,396.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.59,392.76a.52.52,0,0,1-.37-.16.5.5,0,0,1,0-.71c2.84-2.61,8.75-16.41,8.81-16.55a.5.5,0,1,1,.92.39c-.25.58-6,14.15-9,16.9A.55.55,0,0,1,180.59,392.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.82,
    y1: 328.28,
    x2: 189.08,
    y2: 360.12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.08,360.62a.51.51,0,0,1-.46-.3l-14.26-31.84a.5.5,0,0,1,.92-.41l14.26,31.84a.5.5,0,0,1-.25.66A.54.54,0,0,1,189.08,360.62Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.68,424l1.08-42.15-3-27.29s13.78-11.35,26.48-15.95,29.19,9.19,29.19,9.19l3.51,8.38s-3.78,60-3.78,69.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.18,426.07a.5.5,0,0,1-.5-.5c0-9.16,3.59-66.37,3.77-69.36L111,348.06c-1.34-1.09-16.79-13.29-28.6-9-11.63,4.21-24.35,14.26-26.12,15.69l2.94,27L58.18,424a.5.5,0,1,1-1,0l1.08-42.15-3-27.23a.5.5,0,0,1,.18-.44c.13-.11,14-11.46,26.62-16,12.83-4.63,29,8.71,29.68,9.28a.52.52,0,0,1,.14.19l3.51,8.38a.54.54,0,0,1,0,.22c0,.6-3.78,60.08-3.78,69.41A.5.5,0,0,1,111.18,426.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.16,425h0a.49.49,0,0,1-.49-.51l.81-38.3-4.85-19.66a.51.51,0,0,1,.37-.61.5.5,0,0,1,.6.37L65.46,386a.57.57,0,0,1,0,.13l-.81,38.37A.5.5,0,0,1,64.16,425Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.84,362.57a.5.5,0,0,1-.44-.25.49.49,0,0,1,.19-.68l10-5.68a.5.5,0,1,1,.49.87l-10,5.68A.53.53,0,0,1,69.84,362.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.15,223.45a273.53,273.53,0,0,1,9.46,51.61c2.16,27.57,11.62,81.88,11.62,81.88l-13.78-9.19s-8.65-52.15-13-85.39.81-47.55.81-47.55S86.05,197.24,104.15,223.45Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.23,357.44a.57.57,0,0,1-.28-.08l-13.78-9.19a.57.57,0,0,1-.22-.34c-.08-.52-8.69-52.54-13-85.4-3.56-27.36-.67-42.12.45-46.44-4.7-6.91-4.52-7-4.1-7.35s.61-.44,5.36,5.87a.49.49,0,0,1,.07.47s-.1.28-.25.82c1.29,1.89,2.94,4.31,5,7.37a.37.37,0,0,1,.07.14A276.88,276.88,0,0,1,114.11,275c2.13,27.22,11.52,81.28,11.61,81.82a.49.49,0,0,1-.22.51A.53.53,0,0,1,125.23,357.44Zm-13.32-10,12.63,8.42c-1.37-8-9.46-55.72-11.43-80.78a276.66,276.66,0,0,0-9.41-51.43c-1.82-2.63-3.31-4.79-4.52-6.57-1.19,5.1-3.54,19.55-.21,45.2C103.11,294.07,111.3,343.77,111.91,347.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.15,223.45s3.79,21.08,6.22,43.51,1.62,49.72,2.43,54.31,1.08,23,1.08,23a230.27,230.27,0,0,1-11.35-45.4c-3.78-25.94-4-64.31-4-65.39s-.81-16.75-.81-16.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.88,344.74a.51.51,0,0,1-.47-.32A233.38,233.38,0,0,1,102,298.92C98.22,272.72,98,233.83,98,233.45c0-1-.8-16.57-.81-16.73a.5.5,0,0,1,.3-.48.51.51,0,0,1,.56.11l6.48,6.76a.44.44,0,0,1,.13.25c0,.22,3.82,21.36,6.22,43.54,1.53,14.08,1.79,30.38,2,41.16.1,6.4.18,11.45.47,13.12.81,4.58,1.08,22.3,1.09,23.05a.51.51,0,0,1-.4.5ZM98.24,218c.19,3.84.74,14.54.74,15.44,0,.38.24,39.2,4,65.32a240.08,240.08,0,0,0,10.29,42.46c-.11-5.41-.42-16.5-1-19.87-.31-1.76-.39-6.59-.49-13.29-.17-10.76-.43-27-1.95-41.06-2.3-21.17-5.84-41.39-6.18-43.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.34 213.19 110.37 221.83 110.37 229.4 104.15 223.45 103.34 213.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.37,229.9a.52.52,0,0,1-.35-.14l-6.21-5.95a.49.49,0,0,1-.16-.32l-.81-10.27a.51.51,0,0,1,.32-.5.5.5,0,0,1,.57.15l7,8.65a.51.51,0,0,1,.11.31v7.57a.5.5,0,0,1-.31.46A.65.65,0,0,1,110.37,229.9Zm-5.73-6.68,5.23,5V222l-5.9-7.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.32,159.6s2.33,3.33,1.83,11.32-2.83,12.64-2.49,15.81,3.49,7.49,2.49,9-4.66,2.17-4.66,2.17-6.65,9.32-8.32,12-1.66,4.49-4.49,4.66-10-6.16-10-6.16S103.2,216,103,216.68,86.89,203,86.89,203l4-10.32a136.12,136.12,0,0,0-5.33-22.47c-3.66-10.48,8-22,21.47-23.47s25.46,7,26.79,8.82A4.51,4.51,0,0,1,134.32,159.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.06,217.2c-.44,0-2.21-1-16.5-13.79a.48.48,0,0,1-.13-.55l3.94-10.2a135.38,135.38,0,0,0-5.28-22.24c-1.38-4-.76-8.21,1.81-12.28,3.95-6.29,11.83-10.94,20.07-11.85,13.21-1.47,25.6,6.73,27.26,9a5,5,0,0,1,.64,4.22c.51.88,2.22,4.38,1.78,11.42A57.76,57.76,0,0,1,135,181.22a18.48,18.48,0,0,0-.82,5.45,16.74,16.74,0,0,0,1.46,4.39c.9,2.07,1.67,3.87,1,4.93-1,1.47-3.92,2.16-4.78,2.34-.9,1.25-6.68,9.37-8.19,11.79-.41.66-.72,1.27-1,1.81-.83,1.65-1.49,2.95-3.89,3.09-2.65.14-8.25-4.48-9.93-5.92-2.48,3.46-5.09,7.23-5.26,7.72a.54.54,0,0,1-.36.36Zm-.49-.71s0,0,0,.07A.64.64,0,0,0,102.57,216.49Zm-15.09-13.6c5.27,4.72,13.47,11.9,15.33,13.16.92-1.59,4-6,5.48-8a.53.53,0,0,1,.35-.21.48.48,0,0,1,.38.13c2,1.72,7.47,6.12,9.63,6,1.83-.11,2.24-.92,3.06-2.54.28-.56.61-1.19,1-1.89,1.65-2.64,8.07-11.62,8.34-12a.46.46,0,0,1,.31-.2c1-.18,3.62-.87,4.34-1.95.4-.61-.37-2.41-1.05-4a17.81,17.81,0,0,1-1.53-4.67A19.17,19.17,0,0,1,134,181a55.77,55.77,0,0,0,1.66-10.11c.48-7.67-1.72-11-1.74-11a.5.5,0,0,1,0-.46,4.09,4.09,0,0,0-.44-3.52c-1.15-1.59-12.88-10.12-26.34-8.62-7.94.88-15.54,5.35-19.34,11.39-2.39,3.81-3,7.75-1.71,11.41a137.4,137.4,0,0,1,5.35,22.57.54.54,0,0,1,0,.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.17,209.86c1.67-2.66,8.32-12,8.32-12a44.54,44.54,0,0,0-5.32-2.33c-3.16-1.17-10.15-1.33-12.65-1.17s-1-16.47-.67-18.8,4.33-7.16,5.66-10.16,0-3-1.16-4-1.17-6,5.66-6a17.9,17.9,0,0,1,11.31,4.16,4.51,4.51,0,0,0-.5-4c-1.33-1.83-13.31-10.31-26.79-8.82s-25.13,13-21.47,23.47a136.12,136.12,0,0,1,5.33,22.47l-.3.77a4.32,4.32,0,0,0,3.46,2.39c3.33.17,12.48-11,12.48-11s-1.66,9.81-2.33,12.31,4.49,11.15,4.49,11.15,7.16,6.33,10,6.16S121.51,212.52,123.17,209.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.58,215c-3,0-9.48-5.63-10.22-6.28l-.1-.12c-.54-.91-5.24-8.91-4.54-11.54.47-1.79,1.49-7.5,2-10.45-2.67,3.11-8.86,9.88-11.7,9.75a4.75,4.75,0,0,1-3.86-2.64.5.5,0,0,1,0-.43l.25-.65a135.38,135.38,0,0,0-5.28-22.24c-1.38-4-.76-8.21,1.81-12.28,3.95-6.29,11.83-10.94,20.07-11.85,13.21-1.47,25.6,6.73,27.26,9a5,5,0,0,1,.56,4.47.52.52,0,0,1-.35.31A.54.54,0,0,1,134,160a17.54,17.54,0,0,0-11-4c-4,0-5.17,1.7-5.54,2.71a2.42,2.42,0,0,0,.2,2.4c.21.17.42.32.61.45,1.14.77,1.85,1.51.69,4.13a36.77,36.77,0,0,1-2.65,4.48c-1.37,2.11-2.79,4.29-3,5.54-.43,3-1.48,16.52.06,18.18,2.39-.1,9.62,0,12.93,1.25a44.58,44.58,0,0,1,5.39,2.36.45.45,0,0,1,.25.32.54.54,0,0,1-.08.41c-.07.09-6.67,9.34-8.3,12h0c-.41.66-.72,1.27-1,1.81-.83,1.65-1.49,2.95-3.89,3.09Zm-9.5-7c2,1.75,7.4,6.07,9.57,6,1.83-.11,2.24-.92,3.06-2.54.28-.56.61-1.19,1-1.89h0c1.46-2.33,6.61-9.59,8-11.53a46.09,46.09,0,0,0-4.75-2c-3.17-1.17-10.19-1.29-12.45-1.14a1.07,1.07,0,0,1-.88-.37c-2.18-2.36-.33-18.84-.31-19,.21-1.46,1.62-3.63,3.12-5.93a37.93,37.93,0,0,0,2.58-4.35c.91-2.05.49-2.33-.34-2.89-.22-.16-.46-.32-.7-.52a3.35,3.35,0,0,1-.49-3.51c.46-1.25,1.92-3.36,6.48-3.36a18.5,18.5,0,0,1,11,3.76,3.83,3.83,0,0,0-.61-2.8c-1.15-1.59-12.88-10.12-26.34-8.62-7.94.88-15.54,5.35-19.34,11.39-2.39,3.81-3,7.75-1.71,11.41a137.4,137.4,0,0,1,5.35,22.57.54.54,0,0,1,0,.25l-.21.54a3.68,3.68,0,0,0,2.93,1.94c2.27.13,8.46-6.4,12.07-10.8a.51.51,0,0,1,.6-.14.5.5,0,0,1,.28.54c-.06.4-1.67,9.87-2.34,12.36C104.24,199,107.13,204.75,109.08,208Zm14.09,1.82h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5,182.73c-.25,1.36-1,2.36-1.6,2.25s-.94-1.31-.69-2.67,1-2.36,1.59-2.24S129.75,181.38,129.5,182.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.66,177.57a.47.47,0,0,1-.37-.16c-2.34-2.64-5.71-.51-5.85-.42a.5.5,0,0,1-.69-.14.49.49,0,0,1,.15-.69c1.44-.95,4.8-2,7.13.58a.49.49,0,0,1-.37.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84,202.21a.41.41,0,0,1-.16,0,9.59,9.59,0,0,1-5.3-4.94.5.5,0,0,1,.92-.39,8.75,8.75,0,0,0,4.69,4.38.49.49,0,0,1,.32.63A.5.5,0,0,1,125.84,202.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.53,178.24s-2.67-5.49-5.66-4.16-2.5,6.32-.5,9.32,3.66,5,3.66,5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,188.89a.46.46,0,0,1-.38-.18s-1.71-2.05-3.7-5a9.71,9.71,0,0,1-1.46-7.43,4,4,0,0,1,2.18-2.63c3.39-1.51,6.19,4.16,6.31,4.4a.5.5,0,0,1,0,.34l-2.49,10.15a.51.51,0,0,1-.38.37Zm-2.2-14.52a1.78,1.78,0,0,0-.76.17,2.93,2.93,0,0,0-1.62,2,8.78,8.78,0,0,0,1.34,6.59c1.23,1.85,2.34,3.32,3,4.17l2.21-9C107.6,177.55,105.81,174.37,103.83,174.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.89,192.72s-5.16-7.49-10.32-7.16-8.32,9-5.66,12.65a8.19,8.19,0,0,0,10.65,2.33C89.06,198.71,90.89,192.72,90.89,192.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.45,202.08a8.54,8.54,0,0,1-7-3.58c-1.43-2-1.41-5.42.07-8.57,1.36-2.89,3.59-4.71,6-4.87,5.38-.35,10.54,7.06,10.76,7.37a.51.51,0,0,1,.06.43c-.07.26-1.93,6.22-5.57,8.12A9.32,9.32,0,0,1,81.45,202.08Zm-.54-16H80.6c-2,.13-3.92,1.74-5.13,4.3-1.3,2.78-1.37,5.89-.16,7.56a7.74,7.74,0,0,0,10,2.18c2.89-1.52,4.63-6.2,5-7.3C89.5,191.67,85.17,186.05,80.91,186.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.89,204.81s-17.57,11.35-23.78,35.4-3,55.93-3,55.93S50.92,337.21,52,345.32a109.14,109.14,0,0,0,3.78,16.48S69.29,351,79,346.13s21.08.27,21.08.27l16.48,15.4s.27-9.45-5.94-38.37-5.41-80.25-8.11-90-4.86-16.75-4.86-16.75Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.58,362.3a.5.5,0,0,1-.34-.13L99.82,346.82c-1-.41-11.58-4.74-20.57-.24-9.57,4.78-23,15.5-23.15,15.61a.5.5,0,0,1-.79-.23,110.38,110.38,0,0,1-3.8-16.57c-1.07-8,4.76-46.86,5.12-49.26-.16-1.62-3-32.7,3-56a64.3,64.3,0,0,1,24-35.69.5.5,0,0,1,.6,0L98,216.32a.46.46,0,0,1,.16.23c0,.07,2.19,7.14,4.86,16.77,1.11,4,1.62,14.65,2.27,28.14,1,19.92,2.16,44.7,5.85,61.87,6.15,28.64,6,38.1,6,38.49a.47.47,0,0,1-.31.44A.41.41,0,0,1,116.58,362.3ZM83.85,205.44a63.54,63.54,0,0,0-23.26,34.89c-6.12,23.69-3,55.44-3,55.76a.28.28,0,0,1,0,.13c-.06.4-6.19,41.09-5.13,49A107.63,107.63,0,0,0,56.05,361c2.68-2.11,14.22-11,22.75-15.28,9.83-4.91,21,.05,21.5.27a.42.42,0,0,1,.14.09l15.62,14.59c-.13-3.3-1-14-5.91-37.09-3.71-17.25-4.9-42.08-5.86-62-.65-13.43-1.16-24-2.24-27.93-2.47-8.87-4.5-15.57-4.82-16.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.89 199.04 107.69 217.85 103.03 226.84 82.23 204.53 85.89 199.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,227.34a.51.51,0,0,1-.37-.16l-20.8-22.3a.5.5,0,0,1-.05-.62l3.66-5.5a.51.51,0,0,1,.35-.21.5.5,0,0,1,.39.11L108,217.47a.49.49,0,0,1,.12.61l-4.66,9a.52.52,0,0,1-.38.26ZM82.87,204.48l20,21.5,4.15-8L86,199.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.81,343.93a.52.52,0,0,1-.38-.17.51.51,0,0,1,0-.71c.74-.64,18.22-15.8,33.72-10.91a.5.5,0,0,1-.3,1c-15-4.73-32.58,10.55-32.76,10.7A.48.48,0,0,1,62.81,343.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,331a.48.48,0,0,1-.2,0c-6.77-2.87-15.51-.28-15.6-.25a.5.5,0,0,1-.29-1c.37-.11,9.17-2.72,16.28.29a.49.49,0,0,1,.27.65A.51.51,0,0,1,99,331Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,223.18s-9.46,10.54-8.92,16.76,0,20.26,0,20.26S53.62,288.85,55,294s16.76,43.77,18.65,47.83,6.21,14.59,6.21,14.59l14.86-8.11a85.14,85.14,0,0,1-6.48-6.75c-1.62-2.16-3.24-4.33-3.51-5.68s-2.44-14.32-4.33-26.21-4.05-21.89-4.05-21.89L95,242.1",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,356.9a.45.45,0,0,1-.16,0,.49.49,0,0,1-.3-.28c0-.11-4.34-10.58-6.21-14.57s-17.31-42.76-18.67-47.91,7.47-32.09,8.09-34c0-1.08.51-14.24,0-20.13-.55-6.36,8.65-16.69,9-17.13a.5.5,0,0,1,.75.67c-.09.1-9.31,10.45-8.79,16.37.53,6.18,0,20.19,0,20.33a.35.35,0,0,1,0,.14c-3.25,9.86-9.13,29.54-8.09,33.49,1.35,5.13,16.78,43.82,18.61,47.75,1.64,3.5,5.12,11.92,6,14.09l13.77-7.51a76,76,0,0,1-6-6.34c-1.71-2.28-3.31-4.42-3.6-5.88s-2.49-14.64-4.33-26.23c-1.87-11.74-4-21.76-4-21.86a.48.48,0,0,1,0-.29L94.5,241.91a.49.49,0,0,1,.65-.27.5.5,0,0,1,.28.65L76.84,287.81c.28,1.3,2.28,10.78,4,21.76,1.84,11.58,4,24.79,4.32,26.19.24,1.24,1.85,3.39,3.41,5.47a87,87,0,0,0,6.44,6.7.5.5,0,0,1-.11.8l-14.86,8.11A.48.48,0,0,1,79.83,356.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.21,341.54c-1.62-2.16-3.24-4.33-3.51-5.68s-2.44-14.32-4.33-26.21c-.35-2.19-.7-4.32-1.05-6.33-10.49-3.66-16,2.51-18.42,6.8,5,13,11.53,29.14,12.72,31.69,1.89,4.05,6.21,14.59,6.21,14.59l14.86-8.11A85.14,85.14,0,0,1,88.21,341.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,356.9a.45.45,0,0,1-.16,0,.49.49,0,0,1-.3-.28c0-.11-4.34-10.58-6.21-14.57-1.15-2.49-7.54-18.31-12.73-31.72a.54.54,0,0,1,0-.43c2.42-4.26,8.09-10.84,19-7a.51.51,0,0,1,.33.39c.35,2,.71,4.14,1.06,6.33,1.84,11.58,4,24.79,4.32,26.19.24,1.24,1.85,3.39,3.41,5.47l-.39.31.4-.3A86.66,86.66,0,0,0,95,347.93a.5.5,0,0,1-.11.8l-14.86,8.11A.48.48,0,0,1,79.83,356.9ZM61.45,310.16c5.17,13.34,11.47,29,12.62,31.43,1.64,3.51,5.12,11.93,6,14.1l13.77-7.51a76,76,0,0,1-6-6.34h0l.4-.3-.41.29c-1.7-2.27-3.3-4.41-3.59-5.87s-2.49-14.64-4.33-26.23c-.33-2.08-.67-4.11-1-6C69,300.39,63.75,306.21,61.45,310.16Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.83,425.11V374.16a8.27,8.27,0,0,0-8.27-8.27h-111a8.27,8.27,0,0,0-8.27,8.27v50.95m19-48.39a8.28,8.28,0,0,0-8.13,6.77h-4.56v-4.21a8.27,8.27,0,0,1,8.27-8.27h5l2.79,5.71Zm69.76,0h-49.7L393.18,371h53.88Zm32.59,6.77H473a8.28,8.28,0,0,0-8.13-6.77h-3.21l2.8-5.71h4.83a8.27,8.27,0,0,1,8.27,8.27Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.83,425.62a.5.5,0,0,1-.5-.5v-51a7.78,7.78,0,0,0-7.77-7.77h-111a7.78,7.78,0,0,0-7.77,7.77v51a.5.5,0,0,1-1,0v-51a8.78,8.78,0,0,1,8.77-8.77h111a8.78,8.78,0,0,1,8.77,8.77v51A.5.5,0,0,1,483.83,425.62ZM477.56,384H473a.5.5,0,0,1-.5-.41,7.74,7.74,0,0,0-7.63-6.36h-3.21a.49.49,0,0,1-.42-.24.51.51,0,0,1,0-.48l2.8-5.71a.5.5,0,0,1,.45-.28h4.83a8.78,8.78,0,0,1,8.77,8.77v4.21A.5.5,0,0,1,477.56,384Zm-4.16-1h3.66v-3.71a7.78,7.78,0,0,0-7.77-7.77h-4.52l-2.31,4.71h2.41A8.75,8.75,0,0,1,473.4,383Zm-106.32,1h-4.56a.5.5,0,0,1-.5-.5v-4.21a8.78,8.78,0,0,1,8.77-8.77h5a.49.49,0,0,1,.44.28l2.8,5.71a.51.51,0,0,1,0,.48.49.49,0,0,1-.42.24h-3.37a7.74,7.74,0,0,0-7.63,6.36A.5.5,0,0,1,367.08,384ZM363,383h3.66a8.75,8.75,0,0,1,8.53-6.77h2.57l-2.31-4.71h-4.68a7.78,7.78,0,0,0-7.77,7.77Zm82-5.77h-49.7a.5.5,0,0,1-.47-.33l-2.09-5.71a.54.54,0,0,1,.06-.46.52.52,0,0,1,.41-.21h53.88a.52.52,0,0,1,.41.21.54.54,0,0,1,.06.46l-2.09,5.71A.5.5,0,0,1,445,377.22Zm-49.35-1h49l1.72-4.71H393.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.29,425.11V374.16a8.27,8.27,0,0,0-8.27-8.27H362a8.27,8.27,0,0,0-8.27,8.27v50.95m19-48.39a8.28,8.28,0,0,0-8.13,6.77H360v-4.21a8.27,8.27,0,0,1,8.27-8.27h5l2.8,5.71Zm69.76,0h-49.7L390.64,371h53.88ZM475,383.49h-4.57a8.26,8.26,0,0,0-8.12-6.77h-3.21l2.79-5.71h4.84a8.27,8.27,0,0,1,8.27,8.27Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.29,425.62a.5.5,0,0,1-.5-.5v-51a7.78,7.78,0,0,0-7.77-7.77H362a7.78,7.78,0,0,0-7.77,7.77v51a.5.5,0,0,1-1,0v-51a8.78,8.78,0,0,1,8.77-8.77H473a8.79,8.79,0,0,1,8.77,8.77v51A.51.51,0,0,1,481.29,425.62ZM475,384h-4.57a.5.5,0,0,1-.49-.41,7.74,7.74,0,0,0-7.63-6.36h-3.21a.49.49,0,0,1-.42-.24.51.51,0,0,1,0-.48l2.79-5.71a.51.51,0,0,1,.45-.28h4.84a8.78,8.78,0,0,1,8.77,8.77v4.21A.5.5,0,0,1,475,384Zm-4.16-1h3.66v-3.71a7.78,7.78,0,0,0-7.77-7.77h-4.52l-2.31,4.71h2.41A8.75,8.75,0,0,1,470.86,383Zm-106.32,1H360a.5.5,0,0,1-.5-.5v-4.21a8.78,8.78,0,0,1,8.77-8.77h5a.5.5,0,0,1,.45.28l2.8,5.71a.51.51,0,0,1,0,.48.49.49,0,0,1-.42.24h-3.37a7.74,7.74,0,0,0-7.63,6.36A.51.51,0,0,1,364.54,384Zm-4.06-1h3.66a8.75,8.75,0,0,1,8.53-6.77h2.57l-2.31-4.71h-4.68a7.78,7.78,0,0,0-7.77,7.77Zm81.95-5.77h-49.7a.5.5,0,0,1-.47-.33l-2.09-5.71a.54.54,0,0,1,.06-.46.52.52,0,0,1,.41-.21h53.88a.52.52,0,0,1,.41.21.54.54,0,0,1,.06.46l-2.09,5.71A.5.5,0,0,1,442.43,377.22Zm-49.35-1h49l1.72-4.71H391.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.88,424.62s43.77-108.71,45.19-111.32-5.23-19.27-5.47-20-114.41-3.81-114.41-3.81L266,425.11",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,425.62a.48.48,0,0,1-.24-.07.5.5,0,0,1-.2-.68l75.16-135.6a.5.5,0,0,1,.46-.26c.28,0,28.87.78,57.11,1.64,57.5,1.73,57.59,2,57.76,2.51,0,.07.12.33.27.73,4.41,11.51,6.09,17.94,5.16,19.65-1.39,2.56-44.73,110.18-45.17,111.26a.5.5,0,1,1-.92-.37c1.78-4.44,43.79-108.76,45.22-111.37.34-.64.54-3.76-5.22-18.81l-.19-.51c-4.69-.63-75.83-2.69-113.75-3.72l-75,135.34A.51.51,0,0,1,266,425.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.44,
    y1: 413.65,
    x2: 397.8,
    y2: 419.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.8,419.88a.52.52,0,0,1-.21,0,.5.5,0,0,1-.24-.67l2.63-5.73a.5.5,0,0,1,.67-.24.49.49,0,0,1,.24.66l-2.63,5.73A.52.52,0,0,1,397.8,419.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 448.82,
    y1: 308.38,
    x2: 403.34,
    y2: 407.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.34,407.83a.52.52,0,0,1-.21,0,.49.49,0,0,1-.24-.66l45.48-99a.5.5,0,0,1,.9.42l-45.47,99A.5.5,0,0,1,403.34,407.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 454.65,
    y1: 295.7,
    x2: 451.59,
    y2: 302.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.59,302.85a.54.54,0,0,1-.21-.05.49.49,0,0,1-.24-.66l3.06-6.65a.49.49,0,0,1,.66-.25.51.51,0,0,1,.25.66l-3.06,6.66A.52.52,0,0,1,451.59,302.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.63,273.34s-28.78-4.76-45-2.62-36,3.4-36,3.4-28.73-2.92-29.2-.78-10.23,42.1-12.85,54.94-9,32.59-5.71,35,61.61,15.22,62.32,15.22,29.5,9.28,32.35,8.33,5-5.95,5-5.95,17.6-35,23.07-62.32S430.63,273.34,430.63,273.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.06,387.35c-3.5,0-15.56-3.53-26.78-6.9-2.56-.78-4.78-1.44-5.06-1.48h0c-.37,0-59-12.74-62.57-15.31-2.5-1.79-.63-10.15,2.75-23.72,1-4,2-8.2,2.76-11.76,2-10,8.31-36,11.32-48.56.85-3.54,1.42-5.91,1.53-6.39.15-.66.39-1.76,15.3-.81,7.17.46,14.37,1.19,14.44,1.2s19.88-1.28,35.86-3.4,44.81,2.58,45.1,2.62a.51.51,0,0,1,.42.51c0,.18-.54,18.19-6,45.28s-22.94,62.09-23.12,62.44c-.07.19-2.25,5.19-5.28,6.2A2.27,2.27,0,0,1,396.06,387.35ZM364.3,378c.19,0,.9.2,5.27,1.52,7.45,2.24,24.91,7.5,26.89,6.83,2.6-.87,4.67-5.62,4.69-5.67.19-.37,17.65-35.25,23-62.22,4.93-24.66,5.81-41.76,5.92-44.67-3.66-.58-29.53-4.51-44.37-2.54-16,2.11-35.81,3.38-36,3.39-13.23-1.33-27.47-2.1-28.76-1.1-.14.61-.7,2.94-1.52,6.34-3,12.52-9.28,38.57-11.31,48.53-.73,3.58-1.77,7.76-2.77,11.81-2.35,9.41-5.26,21.13-3.13,22.65,3.35,2.4,61.58,15.08,62.06,15.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.31,296.44a.5.5,0,0,1-.24-.93c1.27-.73,2.5-1.38,3.66-1.93a.49.49,0,0,1,.66.23.5.5,0,0,1-.23.67c-1.13.54-2.34,1.18-3.6,1.9A.54.54,0,0,1,396.31,296.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.26,312.61a.5.5,0,0,1-.34-.88,180.72,180.72,0,0,1,17-13.05.5.5,0,0,1,.55.83,176.85,176.85,0,0,0-16.9,13A.5.5,0,0,1,374.26,312.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.82,296.2a.5.5,0,0,1-.34-.88c4.52-4,12.17-7.77,12.49-7.92a.5.5,0,0,1,.67.23.51.51,0,0,1-.24.67c-.07,0-7.83,3.82-12.25,7.77A.51.51,0,0,1,382.82,296.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,374a.49.49,0,0,1-.38-.18,40.87,40.87,0,0,1-5.31-8.2.49.49,0,0,1,.24-.66.5.5,0,0,1,.67.23,40.64,40.64,0,0,0,5.15,8,.48.48,0,0,1-.05.7A.45.45,0,0,1,384,374Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.9,303.83s-14.75,1.06-25.08,8.23-16.44,14.75-17.91,18.33a105,105,0,0,0-3.59,12.44c-.21,1.05-10.54,3.16-10.75,6.11s-.84,8.64-.84,8.64l-3,2.53s27.61,10.12,41.52,17.29S353.7,393,353.7,393s10.75-4.42,15.81-13.49,11.17-13.28,11.38-30.14,2.74-38.15.64-41.73a14.84,14.84,0,0,0-5.48-5.27S351.81,299.41,345.9,303.83Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.7,393.49a.48.48,0,0,1-.26-.07c-.14-.09-13.63-8.5-27.37-15.58s-41.19-17.16-41.46-17.26a.48.48,0,0,1-.32-.38.52.52,0,0,1,.16-.47l2.81-2.4c.11-1,.63-5.83.81-8.42.16-2.19,4.36-3.73,7.74-5a17.36,17.36,0,0,0,3-1.28,104.89,104.89,0,0,1,3.59-12.46c1.39-3.38,7.36-11.11,18.1-18.56,9.77-6.78,23.61-8.16,25.18-8.29,6.18-4.37,29.4-1.61,30.39-1.49l.16.05a15.22,15.22,0,0,1,5.69,5.47c1.42,2.41.9,11.48.25,23-.37,6.36-.74,12.92-.82,19-.16,13.13-3.91,18.75-7.89,24.71-1.18,1.77-2.4,3.6-3.55,5.67-5.09,9.11-15.61,13.52-16.06,13.71A.58.58,0,0,1,353.7,393.49Zm-67.95-33.55c4.65,1.72,28.33,10.6,40.78,17,12.8,6.59,25.39,14.35,27.21,15.48,1.59-.71,10.83-5.1,15.34-13.17,1.17-2.1,2.4-3.95,3.59-5.74,3.89-5.82,7.56-11.33,7.72-24.16.08-6.13.45-12.71.82-19.07.59-10.42,1.15-20.25-.12-22.41a14.4,14.4,0,0,0-5.2-5c-1.62-.18-24.19-2.73-29.69,1.4a.45.45,0,0,1-.26.09c-.15,0-14.74,1.13-24.83,8.14-10.56,7.32-16.4,14.84-17.74,18.11a105.13,105.13,0,0,0-3.56,12.35c-.12.63-1,1-3.66,1.95s-7,2.56-7.08,4.1c-.21,2.92-.84,8.6-.84,8.66a.56.56,0,0,1-.17.32Zm60.15-56.11h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.11,362.66a.51.51,0,0,1-.41-.21.5.5,0,0,1,.12-.7c.07-.05,7.32-5.19,8.9-9.13,1-2.63,2-7.56,2.83-11.92.45-2.37.88-4.61,1.28-6.17,1.08-4.35,5.15-11.62,9-14.85a.5.5,0,1,1,.65.77c-3.62,3.06-7.62,10.21-8.64,14.32-.39,1.54-.82,3.76-1.27,6.12-.84,4.4-1.8,9.39-2.88,12.1-1.69,4.22-8.95,9.36-9.26,9.58A.47.47,0,0,1,290.11,362.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.25,358.08a.48.48,0,0,1-.38-.18,29.09,29.09,0,0,1-2.21-3,.5.5,0,0,1,.84-.54,29.39,29.39,0,0,0,2.13,2.95.51.51,0,0,1-.06.71A.54.54,0,0,1,325.25,358.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.31,352.14a.49.49,0,0,1-.43-.26c-3-5.33-5.55-11.33-5.58-11.39a.51.51,0,0,1,.27-.65.49.49,0,0,1,.65.26c0,.06,2.54,6,5.53,11.29a.5.5,0,0,1-.19.68A.47.47,0,0,1,321.31,352.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,353.66a.51.51,0,0,1-.44-.28c-1.28-2.56-3.73-14.17-3.84-14.66a.51.51,0,0,1,.39-.6.5.5,0,0,1,.59.39c0,.12,2.53,12,3.75,14.42a.49.49,0,0,1-.22.67A.46.46,0,0,1,316,353.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.16,249.45s-8.64,11.81-8.22,14.34,1.27,3.79.85,5.06-5.48,3.58-6.12,5.9S332,279.6,332,279.6s1.48,14.54,2.95,15.8,9.28,1.9,9.28,1.9-.42,6.32-.63,8-8.86,11-9.07,13.49,11.38-4.43,11.38-4.43l8-9.48s5.48-3.37,7.17-6.54,2.74-21.28-3.16-35.19S344.64,246.93,343.16,249.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.13,319.83a1.34,1.34,0,0,1-.68-.15.94.94,0,0,1-.43-.92c.12-1.45,2.32-4.36,5.41-8.31,1.6-2.05,3.58-4.59,3.66-5.2.17-1.38.49-6,.6-7.49-1.86-.17-7.69-.79-9.07-2s-2.81-13.09-3.1-15.94c-.64-.59-2.95-2.93-2.33-5.22.42-1.52,2.32-2.9,4-4.12a8.58,8.58,0,0,0,2.11-1.81,4.13,4.13,0,0,0-.27-2.35,22.19,22.19,0,0,1-.59-2.47c-.44-2.65,7.33-13.37,8.3-14.69a2.56,2.56,0,0,1,2.48-1.11c3.24.2,8.63,4.23,13.15,14.89,6,14,4.86,32.42,3.14,35.63s-6.6,6.26-7.27,6.68l-8,9.43-.13.1C343.49,316.41,337.5,319.83,335.13,319.83ZM345,249.06a1.49,1.49,0,0,0-1.38.65l0,0c-3.3,4.5-8.41,12.26-8.13,14a19.73,19.73,0,0,0,.56,2.36,4.82,4.82,0,0,1,.26,2.93c-.21.65-1,1.27-2.48,2.31s-3.3,2.39-3.62,3.57c-.54,2,2.13,4.31,2.16,4.34a.46.46,0,0,1,.17.32c.72,7.06,1.95,14.77,2.78,15.48,1,.85,6,1.54,9,1.78a.51.51,0,0,1,.46.53c0,.26-.43,6.36-.64,8-.1.84-1.46,2.62-3.86,5.69-2.27,2.91-5.09,6.52-5.2,7.78.75.41,6.06-2.16,10.56-4.85l7.95-9.42.12-.11c.06,0,5.39-3.34,7-6.34s2.66-21-3.18-34.77c-4.65-11-9.91-14.13-12.29-14.28Zm-1.82.4h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,282.84a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5s4.47,0,6.62-2a.49.49,0,0,1,.7,0,.5.5,0,0,1,0,.71C340.86,282.81,336.2,282.84,336,282.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.38,270.61a.51.51,0,0,1-.36-.15,3.73,3.73,0,0,0-3.31-.71.5.5,0,0,1-.61-.35.49.49,0,0,1,.35-.61,4.7,4.7,0,0,1,4.28,1,.5.5,0,0,1-.35.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.43,266.4a.51.51,0,0,1-.46-.3,3.51,3.51,0,0,0-2.32-2.29c-1.59-.31-3.19,1.17-3.2,1.18a.5.5,0,0,1-.71,0,.49.49,0,0,1,0-.7c.08-.08,2-1.85,4.08-1.44a4.41,4.41,0,0,1,3,2.86.49.49,0,0,1-.24.66A.54.54,0,0,1,344.43,266.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.22 297.3 349.91 297.3 343.59 305.31 344.22 297.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.59,305.81a.58.58,0,0,1-.19,0,.5.5,0,0,1-.31-.51l.63-8a.5.5,0,0,1,.5-.46h5.69a.5.5,0,0,1,.45.28.51.51,0,0,1-.06.53l-6.32,8A.51.51,0,0,1,343.59,305.81Zm1.09-8-.47,5.91,4.67-5.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.16,249.45s1.69,14.34,6.54,24.67,7.16,13.49,7.16,13.49,0,8.22-2.52,10.53a7.58,7.58,0,0,1-5.27,2.11s-2.95,4.22,6.53,5.48,12-3.16,15.39-3.58a11.69,11.69,0,0,1,5.06.21,10.87,10.87,0,0,0,.21-5.27c-.64-2.74-1.06-4.85-1.06-4.85s6.33-7.37,6.11-15.81,2.32-13.27-2.31-23.18-29.09-11.59-33.73-11.8-5.27.21-7.38,3.58-8.22,8.43-8.22,12.22,6.12,11.6,6.12,11.6l-.85-5.06S340,255.15,343.16,249.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.81,306.46a24.83,24.83,0,0,1-3.28-.23c-4-.54-6.41-1.67-7.16-3.38a3.12,3.12,0,0,1,.29-2.89.52.52,0,0,1,.44-.21,7.11,7.11,0,0,0,4.9-2c1.89-1.74,2.34-7.67,2.36-10-.49-.71-2.79-4.22-7.11-13.43-3.92-8.34-5.8-19.37-6.38-23.33-2.87,5.12-6.76,11.78-7.4,12.88l.81,4.88a.49.49,0,0,1-.29.54.51.51,0,0,1-.6-.14c-.25-.33-6.22-8-6.22-11.91,0-2.71,2.79-5.89,5.26-8.7a32.84,32.84,0,0,0,3-3.79c2.25-3.6,3.13-4,7.83-3.81,4.86.22,29.35,1.84,34.15,12.09,3.37,7.2,3,11.91,2.62,16.89-.15,2-.31,4.11-.26,6.49.2,7.88-5.06,14.72-6.07,16,.13.62.5,2.42,1,4.6a11.19,11.19,0,0,1-.22,5.54.5.5,0,0,1-.26.29.48.48,0,0,1-.39,0,11.4,11.4,0,0,0-4.82-.19A9.24,9.24,0,0,0,368,303.9,17.3,17.3,0,0,1,358.81,306.46Zm-9.46-5.7a2.08,2.08,0,0,0-.06,1.7c.42.94,1.86,2.17,6.38,2.78,6.28.83,9.37-.86,11.85-2.21a9.8,9.8,0,0,1,3.4-1.38,13.86,13.86,0,0,1,4.77.1,10.29,10.29,0,0,0,.08-4.55c-.63-2.71-1-4.84-1.06-4.86a.49.49,0,0,1,.11-.42c.06-.08,6.2-7.34,6-15.47a64.62,64.62,0,0,1,.26-6.6c.39-5.06.73-9.43-2.53-16.39-4.65-9.93-30.37-11.38-33.29-11.52-4.54-.2-5,.2-6.93,3.35a33.76,33.76,0,0,1-3.14,3.92c-2.35,2.68-5,5.71-5,8,0,2.56,3,7.16,4.78,9.63l-.5-3a.47.47,0,0,1,.06-.33c.05-.09,5.09-8.71,8.22-14.33a.5.5,0,0,1,.53-.25.51.51,0,0,1,.4.44c0,.14,1.73,14.37,6.49,24.5s7.1,13.38,7.12,13.41a.53.53,0,0,1,.09.3c0,.34,0,8.46-2.69,10.9A8.26,8.26,0,0,1,349.35,300.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.58,425.25s2.6-10.65-21-28.58-75.08-40.27-88.33-40.53-24.68,7.28-24.68,7.28-15.07-9.62-24.68-4.68a50.69,50.69,0,0,0-17.41,14.81c-2.07,2.86-9.87,11.17-9.87,11.17s-18.7-3.9-31.43,5.71-17.92,34.68-17.92,34.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.58,425.75l-.11,0a.49.49,0,0,1-.37-.6c0-.12,2.12-10.64-20.86-28.06s-74.5-40.16-88-40.43c-13-.24-24.28,7.12-24.39,7.19a.52.52,0,0,1-.55,0c-.15-.1-14.94-9.4-24.18-4.66a50.42,50.42,0,0,0-17.23,14.66c-2.07,2.85-9.59,10.88-9.91,11.22a.52.52,0,0,1-.47.15c-.18,0-18.63-3.74-31,5.62S155.76,425,155.71,425.22a.5.5,0,0,1-.6.38.49.49,0,0,1-.38-.59c.21-1,5.37-25.36,18.11-35,11.91-9,29.16-6.29,31.55-5.86,1.2-1.29,7.79-8.37,9.65-10.93a51.64,51.64,0,0,1,17.58-15c9.16-4.7,22.76,3.22,24.91,4.54,1.83-1.14,12.59-7.39,24.69-7.19,13.67.27,65.38,23,88.62,40.63,23.63,17.92,21.34,28.65,21.23,29.1A.51.51,0,0,1,390.58,425.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.87,395.35a.49.49,0,0,1-.41-.21,24,24,0,0,0-2.41-2.87.5.5,0,0,1,0-.7.5.5,0,0,1,.71,0,26.14,26.14,0,0,1,2.51,3,.51.51,0,0,1-.12.7A.52.52,0,0,1,331.87,395.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.81,390a.47.47,0,0,1-.32-.12A71.49,71.49,0,0,0,312.6,381L301,374.46l-11.37-4.6a.51.51,0,0,1-.28-.66.5.5,0,0,1,.65-.27l11.44,4.63,11.65,6.56a72.5,72.5,0,0,1,14.07,9,.5.5,0,0,1-.32.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.67,369.37h-.07c-1.07-.15-26.1-3.67-30.27-5.5a.5.5,0,1,1,.4-.91c4,1.77,29.75,5.38,30,5.42a.5.5,0,0,1-.07,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.44,418a.47.47,0,0,1-.39-.2,79.87,79.87,0,0,0-11.51-12,.49.49,0,0,1-.05-.7.5.5,0,0,1,.7-.06,80.88,80.88,0,0,1,11.65,12.12.5.5,0,0,1-.09.7A.52.52,0,0,1,340.44,418Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.88,403.42a.45.45,0,0,1-.31-.11c-15.56-12.53-34-21.17-34.18-21.26a.5.5,0,1,1,.42-.9c.19.08,18.72,8.77,34.38,21.39a.49.49,0,0,1,.08.7A.51.51,0,0,1,325.88,403.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.67,420a.5.5,0,0,1-.49-.4c-.6-3-12.82-16.5-25-26.69a.5.5,0,1,1,.64-.77c11.6,9.73,24.61,23.74,25.31,27.26a.5.5,0,0,1-.39.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.31,391.23a.45.45,0,0,1-.31-.11c-1.7-1.36-3.33-2.59-4.83-3.66-13.29-9.37-14-15.18-14-15.43a.5.5,0,0,1,.45-.54.49.49,0,0,1,.54.45c0,.06.76,5.67,13.56,14.71,1.53,1.07,3.17,2.32,4.88,3.69a.51.51,0,0,1,.08.71A.5.5,0,0,1,279.31,391.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.52,419.25a.5.5,0,0,1-.34-.13c-2.48-2.33-7.77-6-15.72-11a.5.5,0,0,1,.53-.85c8,5,13.35,8.78,15.88,11.15a.49.49,0,0,1,0,.7A.49.49,0,0,1,289.52,419.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.17,406a.5.5,0,0,1-.26-.08c-3.9-2.4-8.32-5-13.13-7.85A78.9,78.9,0,0,0,226,387.73l-21.45-2.51a.5.5,0,0,1-.43-.56.51.51,0,0,1,.55-.44l21.45,2.52a80.06,80.06,0,0,1,31.21,10.43c4.81,2.81,9.23,5.46,13.14,7.86a.5.5,0,0,1-.26.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.9,425.36v-51.2a8.27,8.27,0,0,0-8.27-8.27h-111a8.27,8.27,0,0,0-8.27,8.27v51.2m19-48.64a8.26,8.26,0,0,0-8.12,6.77H63.6v-4.21A8.27,8.27,0,0,1,71.87,371h5l2.79,5.71Zm69.76,0H96.34L94.26,371h53.87Zm32.59,6.77h-4.56a8.27,8.27,0,0,0-8.13-6.77h-3.21l2.8-5.71h4.83a8.27,8.27,0,0,1,8.27,8.27Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.9,425.86a.51.51,0,0,1-.5-.5v-51.2a7.78,7.78,0,0,0-7.77-7.77h-111a7.78,7.78,0,0,0-7.77,7.77v51.2a.5.5,0,0,1-.5.5.51.51,0,0,1-.5-.5v-51.2a8.79,8.79,0,0,1,8.77-8.77h111a8.78,8.78,0,0,1,8.77,8.77v51.2A.5.5,0,0,1,184.9,425.86ZM178.63,384h-4.56a.49.49,0,0,1-.49-.41,7.76,7.76,0,0,0-7.64-6.36h-3.21a.49.49,0,0,1-.42-.24.48.48,0,0,1,0-.48l2.79-5.71a.5.5,0,0,1,.45-.28h4.83a8.78,8.78,0,0,1,8.77,8.77v4.21A.5.5,0,0,1,178.63,384Zm-4.16-1h3.66v-3.71a7.78,7.78,0,0,0-7.77-7.77h-4.52l-2.3,4.71h2.4A8.75,8.75,0,0,1,174.47,383ZM68.16,384H63.6a.5.5,0,0,1-.5-.5v-4.21a8.77,8.77,0,0,1,8.76-8.77h5a.51.51,0,0,1,.45.28l2.79,5.71a.48.48,0,0,1,0,.48.52.52,0,0,1-.43.24H76.28a7.74,7.74,0,0,0-7.63,6.36A.5.5,0,0,1,68.16,384Zm-4.06-1h3.65a8.75,8.75,0,0,1,8.53-6.77h2.57l-2.3-4.71H71.86a7.78,7.78,0,0,0-7.76,7.77ZM146,377.22H96.34a.5.5,0,0,1-.47-.33l-2.08-5.71a.48.48,0,0,1,.06-.46.49.49,0,0,1,.41-.21h53.87a.5.5,0,0,1,.47.67l-2.09,5.71A.5.5,0,0,1,146,377.22Zm-49.35-1h49l1.73-4.71H95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,425.36v-51.2a8.28,8.28,0,0,0-8.27-8.27h-111a8.27,8.27,0,0,0-8.27,8.27v51.2m19-48.64a8.27,8.27,0,0,0-8.13,6.77H60.69v-4.21A8.27,8.27,0,0,1,69,371h5l2.79,5.71Zm69.76,0H93.43L91.35,371h53.87Zm32.58,6.77h-4.56a8.26,8.26,0,0,0-8.13-6.77h-3.2l2.79-5.71h4.83a8.27,8.27,0,0,1,8.27,8.27Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,425.86a.5.5,0,0,1-.5-.5v-51.2a7.78,7.78,0,0,0-7.77-7.77h-111a7.78,7.78,0,0,0-7.77,7.77v51.2a.51.51,0,0,1-.5.5.5.5,0,0,1-.5-.5v-51.2a8.78,8.78,0,0,1,8.77-8.77h111a8.79,8.79,0,0,1,8.77,8.77v51.2A.51.51,0,0,1,182,425.86ZM175.72,384h-4.56a.49.49,0,0,1-.49-.41,7.76,7.76,0,0,0-7.64-6.36h-3.2a.51.51,0,0,1-.43-.24.48.48,0,0,1,0-.48l2.79-5.71a.51.51,0,0,1,.45-.28h4.83a8.77,8.77,0,0,1,8.77,8.77v4.21A.5.5,0,0,1,175.72,384Zm-4.15-1h3.65v-3.71a7.78,7.78,0,0,0-7.77-7.77h-4.52l-2.3,4.71H163A8.76,8.76,0,0,1,171.57,383ZM65.25,384H60.69a.5.5,0,0,1-.5-.5v-4.21A8.77,8.77,0,0,1,69,370.51h5a.5.5,0,0,1,.45.28l2.79,5.71a.48.48,0,0,1,0,.48.5.5,0,0,1-.43.24H73.38a7.76,7.76,0,0,0-7.64,6.36A.49.49,0,0,1,65.25,384Zm-4.06-1h3.65a8.77,8.77,0,0,1,8.54-6.77h2.56l-2.3-4.71H69a7.78,7.78,0,0,0-7.77,7.77Zm81.95-5.77H93.43a.51.51,0,0,1-.47-.33l-2.08-5.71a.5.5,0,0,1,.47-.67h53.87a.49.49,0,0,1,.41.21.48.48,0,0,1,.06.46l-2.08,5.71A.5.5,0,0,1,143.14,377.22Zm-49.36-1h49l1.72-4.71H92.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.19,
    y: 397.44,
    width: 77.08,
    height: 20.32,
    style: {
      fill: "#dedede"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.27,418.25H75.19a.5.5,0,0,1-.5-.5V397.44a.5.5,0,0,1,.5-.5h77.08a.5.5,0,0,1,.5.5v20.31A.5.5,0,0,1,152.27,418.25Zm-76.58-1h76.08V397.94H75.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.86,388.15s-1.68,1.68-4-.43-8-11.38-8.85-13.06,3.58-2.32,6.53-.85S359,383.3,356.86,388.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.18,389.28a3.94,3.94,0,0,1-2.66-1.19c-2.38-2.16-8-11.39-9-13.21a1.26,1.26,0,0,1,.24-1.53c1.16-1.17,4.61-1.16,7,0,2.95,1.47,8.84,9.73,6.56,15a.44.44,0,0,1-.1.16A3.14,3.14,0,0,1,355.18,389.28Zm-8.34-15.79a3.73,3.73,0,0,0-2.33.56.26.26,0,0,0-.05.38c.86,1.73,6.48,10.88,8.74,12.92,1.71,1.56,2.93.76,3.25.5,1.88-4.6-3.38-12.22-6.13-13.59A8,8,0,0,0,346.84,373.49Zm10,14.66h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.08,311.63S350.75,333.77,347,338.19s-9.49,5.48-9.28,7.59,2.11,7,1.69,7.8-4.22,3.79-4.22,3.79L301.22,374l11.59,6.54,35.83-4.22,6.75,7.59,1.47,4.22s12.23-8,15.81-15.6,5.06-22.13,5.06-22.13,1.9-6.12,2.32-8.43,3.16-24.67,2.32-29.51-4-9.28-6.32-10.12-10.12,1.69-12.65,4.64",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.86,388.65l-.16,0a.5.5,0,0,1-.31-.31L355,384.19l-6.51-7.32-35.57,4.18a.46.46,0,0,1-.3-.06L301,374.46a.5.5,0,0,1-.25-.45.52.52,0,0,1,.28-.44L334.89,357a26,26,0,0,0,4-3.6,15.8,15.8,0,0,0-.81-3.68,25.26,25.26,0,0,1-.92-3.84c-.14-1.37,1.33-2.23,3.37-3.41a21.8,21.8,0,0,0,6-4.55c3.71-4.33,13.94-26.23,14.05-26.45a.49.49,0,0,1,.66-.24.5.5,0,0,1,.24.67c-.42.9-10.4,22.24-14.19,26.67a22.75,22.75,0,0,1-6.28,4.77c-1.58.92-2.95,1.71-2.88,2.44a25.55,25.55,0,0,0,.89,3.66c.74,2.61,1,3.82.75,4.41-.45.9-3.71,3.46-4.36,4l-.08.05-33.09,16.23,10.63,6,35.67-4.19a.47.47,0,0,1,.43.16l6.74,7.59a.39.39,0,0,1,.1.16l1.26,3.61c2.38-1.64,12-8.56,15.1-15,3.51-7.42,5-21.82,5-22s1.92-6.21,2.33-8.47,3.13-24.63,2.32-29.34-3.83-8.94-6-9.73c-2-.72-9.6,1.58-12.09,4.49a.5.5,0,1,1-.76-.65c2.64-3.08,10.68-5.7,13.2-4.78s5.76,5.42,6.64,10.5c.86,4.92-1.87,27.25-2.32,29.69s-2.25,8.23-2.33,8.48c0,.5-1.51,14.62-5.08,22.2s-15.49,15.47-16,15.8A.47.47,0,0,1,356.86,388.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.39,373.05a.5.5,0,0,1-.47-.35,22.24,22.24,0,0,0-1.74-4,.5.5,0,0,1,.19-.68.5.5,0,0,1,.68.19,23.31,23.31,0,0,1,1.82,4.15.49.49,0,0,1-.32.62A.45.45,0,0,1,359.39,373.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.48,365.72a.51.51,0,0,1-.4-.2,54,54,0,0,0-13.44-12.15.5.5,0,1,1,.52-.85,55.39,55.39,0,0,1,13.73,12.4.51.51,0,0,1-.11.7A.47.47,0,0,1,355.48,365.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.87,358l-32.65,16,11.59,6.54,35.83-4.22S343.68,363.7,333.87,358Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.81,381.06a.42.42,0,0,1-.24-.07L301,374.46a.5.5,0,0,1-.25-.45.52.52,0,0,1,.28-.44l32.65-16a.52.52,0,0,1,.47,0c9.84,5.72,14.78,18.07,15,18.59a.49.49,0,0,1,0,.44.5.5,0,0,1-.37.24l-35.83,4.21Zm-10.52-7,10.63,6,35-4.12c-1.11-2.54-5.88-12.46-14.07-17.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,362.72a.52.52,0,0,1-.46-.29,13.55,13.55,0,0,0-2.92-4,.49.49,0,0,1,0-.7.5.5,0,0,1,.71,0,14.65,14.65,0,0,1,3.14,4.26.49.49,0,0,1-.24.66A.54.54,0,0,1,360,362.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.58,356.65a.52.52,0,0,1-.29-.09,31.18,31.18,0,0,0-9.14-4.18.5.5,0,0,1-.36-.61.48.48,0,0,1,.6-.36,31.62,31.62,0,0,1,9.48,4.33.51.51,0,0,1,.12.7A.49.49,0,0,1,354.58,356.65Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyPatient);
export default __webpack_public_path__ + "static/media/family_patient.6fe5b73f3dc3660811f8c1334eef2043.svg";
export { ForwardRef as ReactComponent };